/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mushy_Pink_Loris_GrinInputs */

const fr_mushy_pink_loris_grin = /** @type {(inputs: Mushy_Pink_Loris_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Mushy_Pink_Loris_GrinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mushy_pink_loris_grin = /** @type {((inputs?: Mushy_Pink_Loris_GrinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mushy_Pink_Loris_GrinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mushy_pink_loris_grin(inputs)
});